
import { useState, useEffect } from "react";
import urls from "../constants";
import useCookies from '../hooks/useCookies';

const useAuth = () => {

  const [loggedIn, setLoggedIn] = useState(false);
  const [message, setMessage] = useState(null);
  const [successmessage, setsuccessmessage] = useState(null);
  const { deleteCookie } = useCookies();


  useEffect(() => {
    const storedToken = localStorage.getItem("authToken");
    if (storedToken) {
      const storedDate = localStorage.getItem("authTokenExpiration");
      const expirationDate = new Date(storedDate);
      const currentDate = new Date();

      if (currentDate > expirationDate) {
        logout();
      } else {
        setLoggedIn(true);

        // Remaining time until expiration in milliseconds
        const expirationTime = expirationDate.getTime() - currentDate.getTime();

        // Automatically clear localStorage after 7 days
        const timeout = setTimeout(() => {
          logout();
        }, expirationTime);

        return () => clearTimeout(timeout);
      }
    }
  }, []);


  const login = async (username, password, keepMeSignedIn) => {
    try {


      // Set loading to true when the login process starts
      const response = await fetch(urls.LOGIN_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, keepMeSignedIn }),
      });

      if (response.status === 400) {
        const data = await response.json();
        setMessage({ message: data.errors[0].message });
        return;
      }

      if (!response.ok) {
        const data = await response.json();
        setMessage({ message: data.errors[0].message });
        return;
      }

      const data = await response.json();
      const { token, identityId, userType, userProfile } = data;

      if (userProfile.loginDisabled === false) {

        if (userProfile?.mustChangePassword === true) {
          localStorage.setItem("authToken", token)
          await fetch(urls.FORGOT_PASSWORD_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userName: username })
          })
          sessionStorage.setItem('resetEmail', username)
          sessionStorage.setItem('resetStep', '2')
          window.location.href = '/forgot-password'
          return
        }

        localStorage.setItem("username", username);
        localStorage.setItem("authToken", token);

        // Calculate the expiration date (7 days from now)
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 7);

        localStorage.setItem("authTokenExpiration", expirationDate);

        localStorage.setItem("authidentity", identityId);
        localStorage.setItem('userType', userType);
        localStorage.setItem('userProfile', JSON.stringify(userProfile));
        localStorage.setItem('isAuthenticated', 'true');
        setLoggedIn(true);
        setsuccessmessage({ successmessage: "Login successfully!" });
        return { token };

      } else {
        setMessage({ message: "Blocked this user!" });
      }
    } catch (error) {
      setLoggedIn(false)
      setMessage({ message: error.message });
    }

  };

  const logout = async () => {
    setLoggedIn(false);
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem('password');
    localStorage.removeItem("authToken");
    localStorage.removeItem("authTokenExpiration");
    localStorage.removeItem("authidentity");
    localStorage.removeItem('userType');
    localStorage.removeItem('isAuthenticated', 'false');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('lastVisitedPath');
    deleteCookie('email');
    deleteCookie('password');
    deleteCookie('rememberMe');
    deleteCookie('token');
    sessionStorage.clear();
    window.dispatchEvent(new Event("authChange"));
    window.location.href = "/";
  };



  return { loggedIn, successmessage, message, login, logout };
};

export default useAuth;
